<div class="side-nav-section">
  <div class="settings-side-nav-section__header">
    <h3 class="settings-side-nav-section__title">{{ title() | translateLang }}</h3>
  </div>

  <nav class="settings-side-nav-section__nav">
    @for (item of items(); track item.id) {
      <button
        class="settings-side-nav-section__item"
        [class.settings-side-nav-section__item--selected]="isSelected(item.id)"
        [class.settings-side-nav-section__item--highlighted]="item.highlighted"
        (click)="onItemClick(item)"
        type="button"
      >
        <mat-icon class="settings-side-nav-section__icon" [svgIcon]="item.icon"></mat-icon>
        <span class="settings-side-nav-section__label">{{ item.label | translateLang }}</span>
        @if (isSelected(item.id) || item.highlighted) {
          <span class="settings-side-nav-section__indicator"></span>
        }
      </button>
    }
  </nav>
</div>
